




































import ripple from "./ripple.vue";
import tooltip from "./tooltip.vue";
import iconbutton from "./iconButtons.vue";
import popupMenu from "./popupMenu.vue";
import inlineTextEdit from "./inlineTextEdit.vue";
import {parse as parseDate, format as formatDate} from "date-fns";

import { Component, Vue, Prop, Watch} from "vue-property-decorator";
import moment from 'moment'
import { Rows } from "./table.vue";

@Component({
    components: {
        ripple,
        tooltip,
        iconbutton,
        popupMenu,
        inlineTextEdit
    }
})
export default class TableRow extends Vue {
    // tabsManager = tabsManager;
    popupMenuActive = false;
    renaming = false;

    @Prop({}) rowData : Rows;
    // bookItem: BookItem = EmptyBook;

    dateRelation:string = null;
    date0:string=null;
    date1:string=null;
    today:boolean = false;

    popupRows = [
        {
            text: "Open",
            icon: "link",
            function: () => {this.redirect();},
        },
    ]

    tickComplete(){}

    formatDate(){
        if (this.rowData.startsAt) {
            let startMoment = moment(this.rowData.startsAt);
            let endMoment = moment(this.rowData.endsAt);
            let currentTime = (new Date()).getTime();

            this.date0 = moment(this.rowData.startsAt).format("Do MMM, YY");

            // checking if job is current
            if(this.rowData.endsAt){
                this.date1 = moment(this.rowData.endsAt).format("Do MMM, YY");
                if(currentTime >= this.rowData.startsAt && currentTime <= this.rowData.endsAt){
                    this.today = true;
                }
            }else{
                this.today = startMoment.isSame(new Date(), "day");
            }
            
            if(this.today){
                this.dateRelation = this.rowData.endsAt?"":"Today";
            }else{
                this.dateRelation = moment(this.rowData.startsAt).fromNow();
            }
        }
    }
    
    get bookTimeStamp() {
        // if(this.bookItem.updatedAt) {
        //     let date = parseDate(this.bookItem.updatedAt)
        //     return formatDate(date,"MMMM Do YYYY, h:mm:ss A");
        // }

        return "";
    }

    redirect(){
        this.$router.push({ name: 'jobView', params: {jobID: this.rowData.id}});
    };


    renameBook() {
        this.renaming = true;
    }

    async mounted() {
        // this.bookItem = await itemManager.getItemByIdentifier(this.bookData);
        this.formatDate();
    }

    async renameBookFinished(newName) {
        this.renaming = false;
        
        // await this.bookItem.rename(newName);
        this.sendUpdate();
    }

    async deleteBook() {
        // await this.bookItem.delete();
        this.sendUpdate();
    }

    sendUpdate() {
        this.$emit("bookUpdated");
    }

    openDialogBox(){
        this.popupMenuActive = !this.popupMenuActive;        
    }

    @Watch('rowData')
    updateRowData(to, from){
        this.formatDate();
    }

}

